
import React from 'react';
import { Button } from '@/components/ui/button';

interface NotFoundStepProps {
  onNavigateHome: () => void;
}

const NotFoundStep: React.FC<NotFoundStepProps> = ({ onNavigateHome }) => {
  return (
    <div className="min-h-screen bg-brand-light flex flex-col items-center justify-center">
      <h1 className="text-2xl font-bold mb-4">Business Not Found</h1>
      <Button onClick={onNavigateHome}>Return to Dashboard</Button>
    </div>
  );
};

export default NotFoundStep;
